<template>
  <page-template type="norightpanel" class="gestion-points-loterie">
    <template v-slot:toolbar>
        <tool-bar @status-change="$router.push(`/gestion-points${$event}`)" default-gestion-points="/loterie" type="gestion-points" title="Gestion des points" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <div class="d-flex rectangular-element-container">
          <rectangular-element-new title="Nouvelle loterie" link="/gestion-points/loterie/new"></rectangular-element-new>
          <rectangular-element
            v-for="lottery in cachedLotteries"
            :key="lottery._id"
            :title="lottery.title"
            :date="lottery.updatedAt"
            :contributions="lottery.amount"
            :actions="items"
            :id="lottery._id"
            :publish-url="`${apiURL}/lottery/${lottery._id}/activate`"
            :publish-object="lottery"
            @update="updateLotteries()"
            :class="lottery.activated ? 'on-going' : 'to-publish'"
          ></rectangular-element>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularElement from '@/components/RectangularElement.vue'
  import rectangularElementNew from '@/components/RectangularElementNew.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'GestionPointsLoterie',
    components: { pageTemplate, toolBar, rectangularElement, rectangularElementNew },
    data: () => {
      return {
        lotteries: [],
        apiURL
      }
    },
    async created () {
      try {
        // ALL LOTTERIES
        const lotteriesRes = await axios.get(`${apiURL}/lottery/lotteries`)
        this.lotteries = lotteriesRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    },
    computed: {
      cachedLotteries () {
        if (!this.lotteries.length) return []
        return this.lotteries
      },
      items () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.editCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.openCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.duplicateCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.deactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.deleteCb }
        ]
      }
    },
    methods: {
      async updateLotteries () {
        try {
          this.$store.dispatch('loading')
          // ALL LOTTERIES
          const lotteryRes = await axios.get(`${apiURL}/lottery/lotteries`)
          this.lotteries = lotteryRes.data.model
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // EDIT LOTTERY
      editCb (id) {
        this.$router.push(`/gestion-points/loterie/edit/${id}`)
      },
      // OPEN LOTTERY
      openCb (id) {
        this.$router.push(`/gestion-points/loterie/open/${id}`)
      },
      // DUPLICATE LOTTERY
      async duplicateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.post(`${apiURL}/lottery/duplicate/${id}`)
          await this.updateLotteries()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DEACTIVATE LOTTERY
      async deactivateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.put(`${apiURL}/lottery/${id}/deactivate`)
          await this.updateLotteries()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE LOTTERY
      async deleteCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.delete(`${apiURL}/lottery/d/${id}`)
          await this.updateLotteries()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>